import "./Footer.css";
export default function Footer() {
  return (
    <footer>
      <span className="footer-title">John Robinson — Developer</span>
      <span className="footer-text">
        Built with care · No tracking · No ads
      </span>
    </footer>
  );
}
